<template >
  <div>
    <!--Begin nav-->
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.smAndUp"
      app
      color="admiraGreen"
      dark
      flat
      height="60"
    >
      <!--Begin drop menu-->
      <div class="text-center" style="margin-left: -8px;">
        <v-menu transition="scale-transition" v-model="menu" :close-on-content-click="true" :nudge-width="200" offset-y>
          <template  v-slot:activator="{ on }">
            <v-btn v-on="on" fab dark small color="admiraGreen" depressed>
              <v-icon>mdi-apps</v-icon>
            </v-btn>
          </template>
          <v-card  style="top:10px">
            <v-col style="padding:0px;">

              <v-row>
                <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed >
                      <v-icon style="color:#777777">mdi-apple-icloud</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">cloud</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium depressed>
                      <v-icon>mdi-map-marker</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Map</p>
                  </v-col>
                  <v-col  style="" cols="4">
                    <v-btn  icon medium  depressed>
                      <a style="color:#679940" href="http://new.admira.mobi/dashboard" target="_blank">
                        <v-icon>mdi-chart-pie</v-icon>
                      </a>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Dashboard</p>
                  </v-col>
              </v-row>
 

              <v-divider></v-divider>

              <v-row>
                <v-col style="" cols="4">
                    <v-btn  icon medium  depressed>
                      <a style="color:#679940" href="http://new.admira.mobi" target="_blank">
                        <v-icon>mdi-youtube-tv</v-icon>
                      </a>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Digital Signage</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn  icon medium depressed>
                      <a style="color:#679940" href="http://desk.admira.com" target="_blank">
                        <v-icon>mdi-face-agent</v-icon>
                      </a>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Helpdesk</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-face-agent</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Yokup Finance</p>
                  </v-col>
              </v-row>


               <v-row>
                <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-music-note</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Music</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-face-agent</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Robin</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn icon medium depressed>
                      <a style="color:#679940" href="https://alfred.admira.mobi" target="_blank">
                        <v-icon>mdi-office-building</v-icon>
                      </a>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Sitios</p>
                  </v-col>
              </v-row>
  

                <v-row>
                <v-col style="" cols="4">
                    <v-btn  @click="goListSpaces" icon medium  depressed>
                      <a style="color:#679940" href="https://queue.alfred.admira.mobi/" target="_blank">
                        <v-icon>mdi-ticket-outline</v-icon>
                      </a>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Queues</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-calendar</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Citas</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-human-male-male</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Aforo</p>
                  </v-col>
              </v-row>


              <v-row>
                <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-library-shelves</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Muebles</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-human-handsdown</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Avatars</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium depressed>
                      <v-icon>mdi-google-classroom</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Salas</p>
                  </v-col>
              </v-row>
    

              <v-row>
                <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-webcam</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Video Analytics</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-radio-tower</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Radio Analytics</p>
                  </v-col>
                  <v-col style="" cols="4">
                    <v-btn style="cursor:default" icon medium  depressed>
                      <v-icon>mdi-wifi</v-icon>
                    </v-btn>
                    <p style="font-size:12px;margin-bottom:0px;">Social Wifi</p>
                  </v-col>
              </v-row>
              

            </v-col>
          </v-card>
        </v-menu>
      </div>
      <!--End drop menu-->

      <v-toolbar-title class="ml-0 pl-4">
        <h4 @click="goHome" v-if="projectSelected && projectSelected.name " style="cursor:pointer;">{{projectSelected.name}}</h4>
      </v-toolbar-title>
      <v-spacer />
      <!-- projects combobox -->
      <v-col cols="4" style="padding:0; max-width:286px; min-width:136px">
        <v-combobox
          item-text="name"
          elevation="0"
          @change="projectSelectedFunc(projectSelected)"
          :items="allProjects"
          v-model="projectSelected"
          dense
          hide-details
          min-width="261"
          height="60"
          background-color="admiraGreenInputHeader"
          style="top:0;"
        ></v-combobox>
      </v-col>
      <!-- /projects combobox -->
      <!-- language menu -->
      <!-- <v-menu
        :open-on-click="openOnHover"
        :close-on-click="closeOnClick"
        :close-on-content-click="closeOnContentClick"
        :offset-y="offsetY"
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            color="admiraGreen"
            dark
            small
            depressed
            style="top:-2px; border-radius:0; height: 60px; width: 60px; font-size:14px; font-weight: 400;"
          >{{languageSelected}}</v-btn>
        </template>
        <v-list
          dense
          style="background-color: #5c853a; border-radius: 0; width:120px; text-align:left; "
        >
          <v-list-item
            v-for="(item, index) in languages"
            :key="index"
            @click="changeLanguage(item.title)"
            style="height: 10px; font-size:13px;"
          >
            <v-list-item-title style="font-size:14px; font-weight:400">{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
      <!-- /language menu -->
      <!-- user menu new -->
      <v-menu
        :open-on-click="openOnHover"
        :close-on-click="closeOnClick"
        :close-on-content-click="closeOnContentClick"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fab
            color="admiraGreen"
            dark
            depressed
            style="top:-2px; border-radius:0; height: 60px; width: 60px; border: 1px;"
            x-small
          >
            <div class="circle" style="border: 1px solid white; padding:8px; border-radius:50%">
              <v-icon>$user</v-icon>
            </div>
          </v-btn>
        </template>
        <v-list
          dense
          style="background-color: #5c853a; border-radius: 0; width:370px; text-align:left"
        >
          <!-- <v-list-item @click="linkProfile">
            <v-icon small style="margin-right:5px; color: #fff; ">mdi-account-outline</v-icon>
            <v-list-item-title style="font-weight:400">{{userName}}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="linkNotifications">
            <v-icon small style="margin-right:5px; color: #fff; ">mdi-bell-outline</v-icon>
            <v-list-item-title style="font-weight:400">Notificaciones</v-list-item-title>
          </v-list-item> -->

          <v-list-item @click="logout">
            <v-icon small style="margin-right:5px; color: #fff; ">mdi-logout</v-icon>
            <v-list-item-title style="font-weight:400">Log out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- /user menu new-->
    </v-app-bar>
    <!--End nav -->

    <!--Begin drawer-->
    <!-- <v-navigation-drawer
      v-model="drawer"
      permanent
      :mini-variant="mini"
      :clipped="$vuetify.breakpoint.smAndUp"
      width="200"
      app
      style="background-color:#F5F5F5;"
      class="alignDrawer"
      floating
    > -->
      <!--Up close system -->
      <!-- <v-list-item class="px-2 mt-1 mb-1">
        <v-btn icon @click="toggleMini" v-if="mini == true">
          <v-icon color="admiraGreen">mdi-chevron-right</v-icon>
        </v-btn>
        <v-list-item-title icon v-if="mini == false">
          <v-spacer></v-spacer>
        </v-list-item-title>
        <v-btn icon @click="toggleMini">
          <v-icon color="admiraGreen">mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item> -->
      <!--/Up close system-->

      <!--menu list -->
      <!-- <v-list>
        <v-list-item-group :value="leftSideMenuSelected" color="admiraGreen">
          <!--Begin complete list-->
          <!-- <div v-if="userRol == 1 || userRol == 2 || userRol == 6 || userRol == 7 || userRol == 9">
            <v-list-item
              style="padding-right:0; padding-left:0"
              v-for="(item, i) in leftSideMenuOptions"
              :key="i"
            >
              <router-link
                style="display: inline-flex; width: -webkit-fill-available; padding-left: 16px;"
                :to="{path: item.route}"
              >
                <v-list-item-icon>
                  <v-icon style="width:20px ;height:20px; font-size:20px; " v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    style="font-size: 14px; color:gray!important; font-weight: 400  "
                    v-text="item.text"
                  ></v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </div> -->
          <!--End complete list-->

          <!--Begin insitu list-->
          <!-- <div v-if="userRol == 3 || userRol == 5">
            <v-list-item
              style="padding-right:0; padding-left:0"
              v-for="(item, i) in leftSideMenuOptionsInsitu"
              :key="i"
            >
              <router-link
                style="display: inline-flex; width: -webkit-fill-available; padding-left: 16px;"
                :to="{path: item.route}"
              >
                <v-list-item-icon>
                  <v-icon style="width:20px ;height:20px; font-size:20px; " v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    style="font-size: 14px; color:gray!important; font-weight: 400  "
                    v-text="item.text"
                  ></v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </div> -->
          <!--End insitu list-->

          <!--Begin clients list-->
          <!-- <div v-if="userRol == 8 || userRol == 10">
            <v-list-item
              style="padding-right:0; padding-left:0"
              v-for="(item, i) in leftSideMenuOptionsClients"
              :key="i"
            >
              <router-link
                style="display: inline-flex; width: -webkit-fill-available; padding-left: 16px;"
                :to="{path: item.route}"
              >
                <v-list-item-icon>
                  <v-icon style="width:20px ;height:20px; font-size:20px; " v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    style="font-size: 14px; color:gray!important; font-weight: 400  "
                    v-text="item.text"
                  ></v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </div> -->
          <!--End clients list-->
        <!-- </v-list-item-group>
      </v-list> -->
      <!--/menu list -->

      <!-- configuracion -->
      <!-- <template v-slot:append>
        <v-list>
          <v-list-item-group :value="optionBottomSelected" color="admiraGreen">
            <div>
              <v-list-item @click="linkNotifications">
                <v-list-item-icon>
                  <v-badge
                    transition="scale-transition"
                    :value="newNotifications"
                    overlap
                    color="#F6AE2D"
                    :content="newNotifications"
                  >
                    <v-icon>mdi-inbox</v-icon>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    style="font-size: 14px; color:gray!important; font-weight: 400 "
                  >Notificaciones</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              
              <v-list-item
                @click="linkSettingsGeneral"
                v-if="userRol == 1 || userRol == 2 || userRol == 3 || userRol == 6 || userRol == 7"
              >
                  <v-list-item-icon>
                    <v-icon
                      style="width:20px ;height:20px; font-size:20px;"
                      color="blue-grey lighten-4"
                      class="overline"
                    >$settings</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 14px; color:gray!important; font-weight: 400 "
                    >{{settings}}</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-item-group>
        </v-list>
      </template> -->
      <!-- /configuracion -->
    <!-- </v-navigation-drawer> -->
    <!--End drawer-->
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "Navbar",
  data: () => ({
    userRol: localStorage.getItem("rol"),
    userName: localStorage.getItem("name"),
    //Combobox Proyects:
    projectSelected: [],
    projects: this.allProjects,
    // languageSelected: "ES",
    // languages: [
    //   { title: "ES" },
    //   { title: "CA" },
    //   { title: "EN" },
    //   { title: "FR" },
    //   { title: "PT" },
    // ],
    // leftSideMenuSelected: 3,
    optionBottomSelected: null,
    // leftSideMenuOptions: [
    //   {
    //     text: "Sitios",
    //     icon: "$locations",
    //     route: "/showsites/map",
    //     class: "home",
    //   },
    //   { text: "Soportes", icon: "$fitToPage", route: "/devices/list" },
    //   { text: "Propuestas", icon: "mdi-cart-outline", route: "/proposals" },
    //   { text: "Campañas", icon: "mdi-bullhorn-outline", route: "/campaigns" },
    // ],
    // leftSideMenuOptionsInsitu: [
    //   { text: "Sitios", icon: "$locations", route: "/showsites/map" },
    //   { text: "Soportes", icon: "$fitToPage", route: "/devices/list" },
    //   { text: "Campañas", icon: "mdi-bullhorn-outline", route: "/campaigns" },
    // ],
    // leftSideMenuOptionsClients: [
    //   { text: "Campañas", icon: "mdi-bullhorn-outline", route: "/campaigns" },
    // ],

    //navbar:
    openOnHover: true,
    closeOnClick: true,
    closeOnContentClick: true,
    offsetY: true,
    menu: false,
    userName: localStorage.getItem("name"),
    //drawer:
    drawer: true,
    mini: true,
    settings: "Configuración",
    siteName: ""
  }),

  computed: {
    ...mapState(["userData","allProjects"]),
    ...mapState("app", ["newNotifications","actualProject","firstProject"]),
    leftSideMenuSelected() {
      if (
        this.$route.name == "Notifications" ||
        this.$route.path.indexOf("settings") != -1  ||
        this.$route.name == "MyProfile"
      ) {
        return null;
      }
      if (this.userRol == 8 || this.userRol == 10) {
        return 1;
      } else if (this.userRol == 3 || this.userRol == 5) {
        return 2;
      } else {
        return 3;
      }
    },
    // optionBottomSelected() {
    //   if (this.$route.name == "Notifications") {
    //     return 0;
    //   }
    //   if (this.$route.name == "General") {
    //     return 1;
    //   } else {
    //     return null;
    //   }
    // },
  },
  methods: {
    ...mapMutations("app", ["setNotifications","setActualProject","setFirstProject"]),
        ...mapMutations("queues", ["openRightMenuMutation","closeRightMenuMutation"]),
    ...mapActions(["logout"]),
    ...mapActions("app", [
      "getProjects",
      "getMyNotifications",
      "cleanNewNotifications",
      "countNewNotifications",
      "getProjectDetail",
    ]),
        ...mapActions("queues", ["getAllQueues","getAllSpaces","getAllResouces","editQueueStore","showRightMenuProposalStore","hideRightMenuProposalStore","rightMenuTrueNewDeviceTableStore","rightMenuTrueNewDeviceTableStore2","deleteMultipleQueues","deleteOneQueueStore"]),

    linkProfile() {
      this.$router.push({
        name: "MyProfile",
      });
    },
    linkNotifications() {
      this.$router.push({ name: "Notifications",}).catch(err => {err});
    },
    linkSettingsGeneral() {
            this.$router.push({ name: "General",}).catch(err => {err});
    },

    toggleMini() {
      this.mini = !this.mini;
    },
    changeLanguage(item) {
      this.languageSelected = item;
    },
    userAction(item) {
      switch (item) {
        case this.userName:
          break;
        case "notifications":
          break;
        case "log out":
          break;
      }
    },
    projectSelectedFunc(project){
      localStorage.setItem("projectId", project.id);
      localStorage.setItem("projectName", project.name);    
      this.setActualProject(project);
      let idProject = this.actualProject.id;
      this.getProjectDetail(idProject);
      this.getAllSpaces(idProject);  
      this.getAllResouces(idProject);   
      this.getAllQueues(idProject);
      var mobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
        }
      };

      if(mobile.any() != null){
        this.$router.push({
            name: "ListSpacesMobile",
        });
      }else{
        this.$router.push({
            name: "ListSpaces",
        });
      }
    },
    goHome(){
      var mobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
        }
      };

      if(mobile.any() != null){
        this.$router.push({
            name: "ListSpacesMobile",
        });
      }else{
        this.$router.push({
            name: "ListSpaces",
        });
      }
      
      this.closeRightMenuMutation();  
    },
    goCloud(){
      this.$router.push({
            name: "Cloud",
        });
    },
    goGeneralMap(){
        this.$router.push({
            name: "GeneralMap",
        });
    },
    goDashboard(){
        this.$router.push({
            name: "Dashboard",
        });
    },
    goListSpaces(){
      this.$router.push({
            name: "ListSpaces",
        });
    },
    changeName(to){
      if (to.name == "ListSpaces") {
        this.siteName = "Admira Sitios"
      }else if(to.name == "Cloud" ){
        this.siteName = "Admira Cloud"
      }else if(to.name == "GeneralMap" ){
        this.siteName = "Admira Map"
      }else if(to.name == "Dashboard" ){
        this.siteName = "Admira Dashboard"
      }
    },
  },
  beforeUpdate() {
    //this.cleanNewNotifications()
    //this.countNewNotifications()
  },

  async created() {

    let anyProj =localStorage.getItem('projectId')    
    let actualProj = {};
    actualProj.id = localStorage.getItem('projectId')
    actualProj.name = localStorage.getItem('projectName')
    this.projectSelected = actualProj
    this.setActualProject( this.projectSelected);
    if (this.projectSelected.id) {
      this.getProjectDetail(this.projectSelected.id);
    }
    let to = this.$router.currentRoute;
    this.changeName(to)
  },
  watch: {
    $route(to, from) {
      this.changeName(to);
    },
  },
};
</script>

<style scoped>
/* remove native paddings from toolbar header: */
>>> .v-toolbar__content {
  padding-right: 12px !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

/* start customize v-menu dropdown: */
.v-menu__content {
  border-radius: 0;
  box-shadow: none !important;
}

.v-menu__content .v-list {
  background-color: #689840;
  border-radius: 0 !important;
  text-align: left;
}

>>> .v-list-item__title {
  color: #fff !important;
}

>>> .v-select__slot {
  padding-left: 15px !important;
}

/* end customize v-menu dropdown */

/** margin between icon and title in the side menu */
>>> .v-list-item__icon:first-child {
  margin-right: 16px;
}

.alignDrawer {
  text-align: left;
  padding: -60px;
}

.newtext {
  font-family: "Roboto", sans-serif;
}
a {
  text-decoration: none;
}
.admira-icon {
  font-family: "Admira icons";
}
>>> .v-badge__badge {
  font-size: 10px;
  height: 17px;
  min-width: 17px;
  padding: 4px 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue